(() => {

const listener = () => {
  const returnType = qs('#form_return_type');
  const altproduct = qs('#form_alternative_product');

  returnType.addEventListener('change', () => {
    if(returnType.value == "Alternative") {
      altproduct.closest('.form-group').style.display = 'block';
    } else {
      altproduct.closest('.form-group').style.display = 'none';
    }
  });

  triggerEvent(returnType, 'change'); 
};

if(scriptReady) { 
  listener(); 
} else { 
  if(document.addEventListener) { 
    document.addEventListener('scriptReady', listener);
  } else { 
    document.attachEvent('scriptReady', listener);
  };
}

})();